module.exports = __webpack_public_path__ + "static/media/edit-blue.e9583fb2.svg";